import { createContext } from 'react';

import { ChatSocketStatus } from './types';

export type ChatRealtimeContextValue = {
  status: ChatSocketStatus;
  degradedChannels: string[];
};

export const ChatRealtimeContext = createContext<ChatRealtimeContextValue>({
  status: 'idle',
  degradedChannels: [],
});
